import React, { useEffect, useRef, useState } from "react";
import Fade from "react-reveal/Fade";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFieldArray, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import {
  backButtonHandler,
  getSetupDetails,
  saveSetupWizardForm,
} from "../../../Redux/actions";
import SWInterface from "../../Components/Layout/SWInterface";
import { checkNull, removeUnderScore } from "../../../helpers";
import BtmButtons from "../../Components/BtmButtons";

const numMsg = "Must be a valid number";
const reqMsg = "This field is required";
const schema = yup
  .object({
    finance_account: yup.array().of(
      yup.object().shape({
        name: yup.string().required(reqMsg),
        is_bank_account: yup.string().required(reqMsg),
        bank_name: yup.string().required(reqMsg),
        bank_account_no: yup.string().required(),
        opening_balance: yup.number(numMsg).positive(numMsg).required(reqMsg),
      })
    ),
  })
  .required();

const SetupWizardSix = (params) => {
  const initialForm = {
    finance_account: [],
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "finance_account",
  });

  const [inputForm, setInputForm] = useState(initialForm);
  const isLogoutRef = useRef(false);
  const submitBtnRef = useRef(null);

  const changeInputHandler = (index, input, val) => {
    setValue(`finance_account.${index}.${input}`, val);
    inputForm.finance_account[index][input] = val;
    setInputForm({ ...inputForm });
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const { account, subAccounts, acId } = useSelector(
    (state) => state.authReducer.setup_wizard_details
  );
  const { user } = useSelector((state) => state.authReducer.user_details);

  const addInputRow = () => {
    const appendingData = {
      name: "",
      is_bank_account: "Yes",
      bank_name: "",
      bank_account_no: 0,
      opening_balance: 0,
    };
    append(appendingData);
    inputForm.finance_account.push(appendingData);
  };

  const removeInputRow = (index) => {
    remove(index);
    setInputForm({
      ...inputForm,
      finance_account: inputForm.finance_account.filter(
        (acc, i) => i !== index
      ),
    });
  };

  useEffect(() => {
    if (user?.merchant?.parent_merchant_id > 0) {
      dispatch(backButtonHandler());
    } else {
      dispatch(getSetupDetails(5));
    }
  }, []);

  const getErrorContainer = (index, type) => {
    return (
      <Fade
        right
        collapse
        when={
          errors && errors?.finance_account?.[index]?.[type]?.message
            ? true
            : false
        }
      >
        <label className="error">
          {errors?.finance_account?.[index]?.[type]?.message
            ? removeUnderScore(
                errors?.finance_account?.[index]?.[type]?.message
              )
            : ""}
        </label>
      </Fade>
    );
  };
  const submitForm = (data) => {
    console.log("submitForm", data);
    if (acId && checkNull(acId, false)) {
      data.parent_finance_account_id = acId;
    }
    dispatch(saveSetupWizardForm("five", data, isLogoutRef?.current));
  };

  const submitNextHandler = (isLogoutType = false) => {
    isLogoutRef.current = isLogoutType;
    if (submitBtnRef !== null) {
      submitBtnRef.current.click();
    }
  };

  return (
    <SWInterface step={5}>
      <div className="steps-content">
        <div className="steps-div_outer">
          <form
            className="frmStripePayment"
            onSubmit={handleSubmit(submitForm)}
          >
            <h4 class="event-alert mb-0"> Payment Accounts </h4>
            <p>
              To expedite your onboarding process onto GoGMGo, please take this
              time to create your payment account information that can be
              referred to later in in setup process. Please only use this for
              Cash &amp; Cash Equivalent accounts, liability payment accounts
              can either be setup in the Payee Upload setup step (by selecting
              “Own AP Account” for the Default Payment Account selection) or in
              the Chart of Accounts in the Finance Settings once the Setup
              Wizard process is complete.
            </p>

            <h4 class="sm-hd"> Add Payment Accounts</h4>
            <div class="row_buttons">
              <div class="align-right custom_rquer">
                <label class="required mx-4">Mandatory Fields</label>
                <label class="numrical">Numeric Fields</label>
              </div>
            </div>

            <div className="table-responsive">
              <table
                class="checklist-table remove-space inventory_table"
                width="100%"
                cellspacing="0"
                cellpadding="0"
              >
                <thead>
                  <tr>
                    <th>
                      <label class="required">Asset Account</label>
                    </th>
                    <th>
                      <label class="required">Sub-Account Name</label>
                    </th>
                    <th>
                      <label class="required">Bank Account?</label>
                    </th>
                    <th>
                      <label class="required">Custodian Bank Name</label>
                    </th>
                    <th>
                      <label class="required numrical">Account Number</label>
                    </th>
                    <th>
                      <label class="required numrical">Opening Balance</label>
                    </th>
                    <th className="delt-btn"></th>
                  </tr>
                </thead>
                <tbody class="tbody">
                  {subAccounts &&
                    subAccounts.length > 0 &&
                    subAccounts.map((subAccount, ind) => {
                      return (
                        <tr key={ind}>
                          <td>Cash &amp; Cash Equivalents</td>
                          <td>{subAccount?.name}</td>
                          <td>
                            {subAccount?.is_bank_account == 1 ? "Yes" : "No"}
                          </td>
                          <td>{subAccount?.bank_name ?? ""}</td>
                          <td>{subAccount?.bank_account_no ?? ""}</td>
                          <td>{subAccount?.current_balance ?? "0.00"}</td>
                          <td></td>
                        </tr>
                      );
                    })}
                  {console.log("errors", errors)}
                  {fields.map((item, index) => (
                    <tr class="cce" id={`row${item.id}`} key={item.id}>
                      {" "}
                      <td>
                        <div class="input-group select-div dell-padding">
                          <select
                            class="custom_int required valid"
                            maxlength="200"
                            type="text"
                          >
                            {" "}
                            <option>Cash &amp; Cash Equivalents</option>{" "}
                          </select>
                        </div>
                      </td>{" "}
                      <td>
                        <input
                          {...register(`finance_account.${index}.name`)}
                          onChange={(event) =>
                            changeInputHandler(
                              index,
                              "name",
                              event?.target?.value
                            )
                          }
                          value={inputForm?.finance_account?.[index]?.name}
                          id="name0"
                          class="custom_int"
                          type="text"
                        />
                        {getErrorContainer(index, "name")}
                      </td>{" "}
                      <td>
                        <div class="input-group select-div">
                          <select
                            id="isba0"
                            {...register(
                              `finance_account.${index}.is_bank_account`
                            )}
                            onChange={(event) =>
                              changeInputHandler(
                                index,
                                "is_bank_account",
                                event?.target?.value
                              )
                            }
                            value={
                              inputForm?.finance_account?.[index]
                                ?.is_bank_account
                            }
                            class="custom_int required isbank valid"
                            type="text"
                          >
                            {" "}
                            <option value="Yes">Yes</option>{" "}
                            <option value="0">No</option>{" "}
                          </select>
                          {getErrorContainer(index, "is_bank_account")}
                        </div>
                      </td>{" "}
                      <td>
                        <input
                          id="ba0"
                          class="custom_int required bankname"
                          {...register(`finance_account.${index}.bank_name`)}
                          maxlength="200"
                          type="text"
                        />
                        {getErrorContainer(index, "bank_name")}
                      </td>{" "}
                      <td>
                        <input
                          class="custom_int required acno"
                          id="ban0"
                          {...register(
                            `finance_account.${index}.bank_account_no`
                          )}
                          maxlength="200"
                          type="text"
                        />
                        {getErrorContainer(index, "bank_account_no")}
                      </td>{" "}
                      <td>
                        <input
                          class="custom_int currency"
                          id="ob0"
                          {...register(
                            `finance_account.${index}.opening_balance`
                          )}
                          maxlength="200"
                          type="text"
                        />
                        {getErrorContainer(index, "opening_balance")}
                      </td>{" "}
                      <td className="col-2">
                        <span class="dell">
                          <a
                            onClick={() => removeInputRow(index)}
                            class="deleteSt circle_icon"
                            val="492"
                          >
                            <i class="iconSprites delete-icon"></i>
                          </a>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div class="my-4">
              <a
                onClick={() => addInputRow()}
                class="btn green-btn-revert add-plus savecce2"
              >
                <i class="i-icon"> </i> Add Account{" "}
              </a>
            </div>

            <button
              type="submit"
              style={{ display: "none" }}
              ref={submitBtnRef}
            >
              Submit
            </button>
            <BtmButtons submitHandler={submitNextHandler} />
          </form>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardSix;
